let docStyle = window.getComputedStyle(document.body);
let textColor = docStyle.getPropertyValue('--text-color');
let gridColor = docStyle.getPropertyValue('--chart-grid-color');
let seriesDefaultColor = docStyle.getPropertyValue('--chart-series-default-color');

let defaultAxis = {
  stroke: textColor,
  grid: {
    width: 1,
    stroke: gridColor
  },
  ticks: {show: false},
}

let defaultYAxis = {
  ...defaultAxis,
  size: 50,
}

let defaultSeries = {
  points: {show: false},
  width: 1,
  stroke: "#000",
}

window._chartOptions = {}